/**
 * Fetch wrapper that automatically includes credentials (session cookie)
 * and CSRF token for authenticated API requests.
 *
 * This is a drop-in replacement for the native fetch() function.
 *
 * Usage:
 *   import fetchWithAuth from '../utils/fetchWithAuth';
 *   fetchWithAuth('/api/polls/') // credentials automatically included
 *   fetchWithAuth('/api/polls/', { method: 'DELETE' }) // CSRF token included
 */

// Helper to get CSRF token from cookie
const getCsrfToken = () => {
  const name = 'csrftoken';
  const cookies = document.cookie.split(';');
  for (let cookie of cookies) {
    const trimmed = cookie.trim();
    if (trimmed.startsWith(name + '=')) {
      return trimmed.substring(name.length + 1);
    }
  }
  return null;
};

const fetchWithAuth = (url, options = {}) => {
  const headers = { ...options.headers };

  // Add CSRF token for non-GET requests
  const method = (options.method || 'GET').toUpperCase();
  if (method !== 'GET' && method !== 'HEAD' && method !== 'OPTIONS') {
    const csrfToken = getCsrfToken();
    if (csrfToken) {
      headers['X-CSRFToken'] = csrfToken;
    }
  }

  const config = {
    ...options,
    headers,
    credentials: 'include',
  };

  return fetch(url, config);
};

export default fetchWithAuth;
